import { FunctionComponent } from 'react';

const Footer: FunctionComponent = (): JSX.Element => {
  const PUBLIC_URL = process.env.PUBLIC_URL;
  const VERSION = process.env.REACT_APP_VERSION;

  return (
    <footer className="border-top border-warning">
      <div className="container">
        <div className="d-flex justify-content-between py-2">
          <div className="d-flex flex-row">
            <img
              src={`${PUBLIC_URL}${'/assets/images/logo_sti_nome.png'}`}
              alt="STI"
              className={'logo-sistema d-none d-lg-block'}
            />
            <img src={`${PUBLIC_URL}${'/assets/images/logo_sti.svg'}`} alt="STI" className={'logo-sistema d-block d-lg-none'} />
            <span className="text-gray align-middle d-none d-md-block ms-3">
              {`© 2022-${new Date().getFullYear()} Gerência de Sistemas de Informação - STI/UFPB`}
            </span>
            <span className="text-gray align-middle d-block d-md-none ms-3">{`© 2022-${new Date().getFullYear()} GSI - STI/UFPB`}</span>
          </div>
          <div className="d-flex">SCE - {VERSION}</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
